import React from 'react';
import {ApolloProvider} from '@apollo/client';
import Client from './components/apolloClient/apolloClient';
import {install} from '@material-ui/styles';
import Routes from './Routes';
import ThemeProvider from './Theme';
import {SnackbarProvider} from 'notistack';
import OfflineIndicator from './components/OfflineIndicator';
import {shouldUsePWAMode} from './util/pwaUtils';

export default function App() {
    install();

    return (
        <ApolloProvider client={Client}>
            <ThemeProvider>
                <SnackbarProvider maxSnack={5}>
                    {/* Show offline indicator for PWA mode */}
                    {shouldUsePWAMode() && <OfflineIndicator/>}
                    <Routes/>
                </SnackbarProvider>
            </ThemeProvider>
        </ApolloProvider>
    );
}